<template>
  <div v-if="cta.display_action && show" class="cta-btn-wrapper">
    <a
      :class="[this.cta.corner_style, 'cta-button']"
      data-testid="cta-button"
      v-on:click="customClick()"
      :target="this.cta.target || '_blank'"
      :href="outboundLink"
      :style="{ color: this.cta.text_color, 'background-color': this.cta.button_color }"
    >
      {{ this.cta.text }}
    </a>
    <div v-if="hoverable" class="cta-btn-overlay"></div>
  </div>
</template>

<script>
import track from "../../../tracking";
import { mapState } from 'vuex';

export default {
  name: "cta-button",
  props: {
    hoverOnly: { type: Boolean, default: false }
  },
  computed: {
    ...mapState({
      item: state => state.item,
    }),
    show: function(){
      return this.cta.display_action;
    },
    cta: function(){
      // TODO: get this all from state
      return this.$root.call_to_action.attributes;
    },
    ctaId: function(){
      // TODO: get this all from state
      return this.$root.call_to_action.id;
    },
    show: function(){
      if(this.item.attributes.view_limit_reached) return false
      if(this.hoverOnly && !this.hoverable) return false
      if(!this.hoverOnly && this.hoverable) return false

      return true;
    },
    hoverable: function(){
      return this.cta.appearance.startsWith('cta-button-hover');
    },
    outboundLink: function () {
      if (this.cta.javascript_code) {
        return "#";
      }

      if (!this.ctaId) {  // unsaved
        return this.cta.link;
      }

      return this.$root.routes.click_call_to_action_path(this.ctaId);
    },
  },
  methods: {
    customClick: function () {
      // Track clicking free video cta
      if (this.ctaId === "free" && this.link) {
        track("free_video_cta_clicked", {
          itemId: this.item.id,
        });
      }

      // This is only provided when the item is part of an onboarding collection and has a 'raw' link (starts with `raw:`).
      // This is a way for admins to create buttons that, e.g., open a modal dialog.
      if (this.cta.javascript_code) {
        eval(this.cta.javascript_code);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~rails/assets/stylesheets/variables/cta_sizes.sass";

.cta-button-hover {
  .cta-btn-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .cta-button {
      margin-top: 0;
      box-shadow: 0 0 0.75rem 0 rgba(0, 0, 0, 0.7);
    }

    .cta-btn-overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: #0004;
    }
  }
}

.cta-button {
  min-width: 170px;
  text-decoration: none;
  text-align: center;
  padding: 10px;
  z-index: 100;
  display: inline-block;
  -moz-transition: none;
  -webkit-transition: none;
  -o-transition: color 0 ease-in;
  transition: none;

  &.cta-square {
    border-radius: 0;
  }
  &.cta-slightly-rounded {
    border-radius: 5px;
  }
  &.cta-rounded {
    border-radius: 5em;
  }
  &:hover {
    text-decoration: none;
  }
  &:visited {
    text-decoration: none;
  }
}
</style>
